import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="keyframe, rhombus" maskId="round-filled-radius-1-stroke-1.5-IconKeyframe"><path d="M13.2373 2.42662C12.5539 1.74321 11.4458 1.74321 10.7624 2.42662L2.42663 10.7624C1.74321 11.4458 1.74321 12.5538 2.42662 13.2372L10.7624 21.5731C11.4458 22.2565 12.5539 22.2565 13.2373 21.5731L21.5731 13.2372C22.2565 12.5538 22.2565 11.4458 21.5731 10.7624L13.2373 2.42662Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
